import IconButton from '#components/a/IconButton'
import IconText from '#components/a/IconText'
import TextareaResize from '#components/a/form/TextareaResize'
import QualificationModal from '#components/m/QualificationsModal'
import toolInputVerification from 'ag-common/tools/inputVerification'
import { bold, color, underline } from 'ag-common/tools/textFormat'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'
import TaetigkeitWorktime from './TaetigkeitWorktime'

export default class Taetigkeit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isActive: false,
    }
    this.textarea = React.createRef()
    this.button = React.createRef()
  }

  deleteTaetigkeit = () => {
    const {handleDeleteTaetigkeit, taetigkeit} = this.props
    handleDeleteTaetigkeit(taetigkeit.id)
  }

  updateStunden = rawInput => {
    const {handleChangeTaetigkeit, taetigkeit} = this.props
    handleChangeTaetigkeit({
      ...taetigkeit,
      stunden: toolInputVerification.checkForNumberLimit(0, 99, rawInput),
    })
  }

  updateMinuten = rawInput => {
    const {handleChangeTaetigkeit, taetigkeit} = this.props
    handleChangeTaetigkeit({
      ...taetigkeit,
      minuten: toolInputVerification.checkForNumberLimit(0, 59, rawInput),
    })
  }

  onChangedText = rawInput => {
    const {handleChangeTaetigkeit, taetigkeit} = this.props
    handleChangeTaetigkeit({
      ...taetigkeit,
      text: rawInput,
    })
  }

  updateTaetigkeit = () => {
    const {handleUpdateTaetigkeit, taetigkeit} = this.props
    handleUpdateTaetigkeit(taetigkeit)
  }

  onQualificationsUpdated = qualifications => {
    const {handleUpdateTaetigkeit, taetigkeit} = this.props
    const updatedTaetigkeit = {
      ...taetigkeit,
      qualifikationen: qualifications,
    }
    handleUpdateTaetigkeit(updatedTaetigkeit)
  }

  getClassName = () => {
    const {canEditQualification} = this.props
    let className = 'taetigkeit'
    if (!canEditQualification) {
      className += ' taetigkeit--qualifications-disabled'
    }
    return className
  }

  formatText = formatFunc => {
    const {value} = this.textarea.current
    const {handleChangeTaetigkeit} = this.props
    const currentTextarea = this.textarea.current
    const {selectionStart, selectionEnd} = currentTextarea

    const result = formatFunc(value, selectionStart, selectionEnd)

    handleChangeTaetigkeit({
      ...this.props.taetigkeit,
      text: result,
    })

    this.textarea.current.value = result
    this.textarea.current.setSelectionRange(selectionStart+1, selectionEnd+1)
  }

  render() {
    const {
      canEditQualification,
      isDisabled,
      taetigkeit,
      withQualification,
      withWorktime,
      allowedQualificationCount,
      userId,
    } = this.props

    const qualificationsText =
      taetigkeit.qualifikationen && taetigkeit.qualifikationen.length > 0
        ? taetigkeit.qualifikationen.join(', ')
        : i18n.t('taetigkeit_assign_qualification')

    const qualificationLink = <IconText icon="chain" event={() => {}} modifier="blue" text={qualificationsText} />

    const preventBlur = event => {
      event.preventDefault()
    }

    return (
      <div className={this.getClassName()}>
        {this.state.isActive && (
          <div className="formatbuttons">
            <IconButton
              onMouseDown={preventBlur}
              event={() => this.formatText(bold)}
              icon="boldText"
              ref={this.button}
            />
            <IconButton
              onMouseDown={preventBlur}
              event={() => this.formatText(underline)}
              icon="underlineText"
              ref={this.button}
            />
            <IconButton
              onMouseDown={preventBlur}
              event={() => this.formatText(color)}
              icon="colorText"
              ref={this.button}
            />
          </div>
        )}
        <div
          onFocus={() => this.setState({isActive: true})}
          onBlur={() => {
            const handleBlur = () => {
              this.setState({isActive: false})
            }
            window.setTimeout(handleBlur, 100)
          }}>
          <TextareaResize
            dataType="text"
            disabled={isDisabled}
            onBlurHandle={this.updateTaetigkeit}
            onChangeHandle={elem => this.onChangedText(elem.target.value)}
            placeholder={i18n.t('taetigkeit_text_placeholder')}
            defaultValue={taetigkeit.text}
            ref={this.textarea}
            autoFocus
          />
        </div>
        <div className="row taetigkeit__metadata">
          {withWorktime && (
            <TaetigkeitWorktime
              taetigkeitId={taetigkeit.id}
              stunden={taetigkeit.stunden}
              minuten={taetigkeit.minuten}
              isDisabled={isDisabled}
              updateTaetigkeit={this.updateTaetigkeit}
              updateStunden={this.updateStunden}
              updateMinuten={this.updateMinuten}
            />
          )}
          {withQualification && (
            <div className="taetigkeit__qualification">
              {canEditQualification ? (
                <QualificationModal
                  trigger={qualificationLink}
                  currentQualifications={taetigkeit.qualifikationen}
                  confirm={this.onQualificationsUpdated}
                  allowedQualificationCount={allowedQualificationCount}
                  userId={userId}
                />
              ) : (
                qualificationLink
              )}
            </div>
          )}
          <div className="taetigkeit__delete">
            {!isDisabled && (
              <IconText
                id={`deleteTaetigkeitButton_${taetigkeit.id}`}
                icon="delete"
                event={this.deleteTaetigkeit}
                onMouseDown={preventBlur}
                modifier="grey"
                text={i18n.t('taetigkeit_delete')}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

Taetigkeit.propTypes = {
  handleDeleteTaetigkeit: PropTypes.func,
  handleUpdateTaetigkeit: PropTypes.func,
  isDisabled: PropTypes.bool,
  taetigkeit: PropTypes.object,
  handleChangeTaetigkeit: PropTypes.func,
  withWorktime: PropTypes.bool,
  withQualification: PropTypes.bool,
  canEditQualification: PropTypes.bool,
  allowedQualificationCount: PropTypes.number,
  userId: PropTypes.number,
}

Taetigkeit.defaultProps = {
  withQualification: true,
  withWorktime: true,
}
